export var CONTRACT_TYPE;
(function (CONTRACT_TYPE) {
    CONTRACT_TYPE["STORAGE"] = "STORAGE";
    CONTRACT_TYPE["STAKING"] = "STAKING";
    CONTRACT_TYPE["FARMING"] = "FARMING";
})(CONTRACT_TYPE || (CONTRACT_TYPE = {}));
